import script from "./TwoFactorAuthEnableModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthEnableModal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__